export function worldToScreen(x, y, cameraX, cameraY, cameraScale) {
  const screenX = (x - cameraX) * cameraScale;
  const screenY = (y - cameraY) * cameraScale;
  return { screenX, screenY };
}

export function screenToWorld(screenX, screenY, cameraX, cameraY, cameraScale) {
  const x = screenX / cameraScale + cameraX;
  const y = screenY / cameraScale + cameraY;
  return { x, y };
}
